import styled from "styled-components";

export default styled.div`
    display: flex;
    justify-content: flex-start;
    flex-direction: row;
    align-items: flex-start;
    align-content: flex-start;
    box-sizing: border-box;;


    @media screen and (max-width: 1260px) {
        width: 100%;
        justify-content: space-around;
    }

    @media screen and (max-width: 920px) {
        justify-content: flex-start;
        align-items: flex-start;
    }

    @media screen and (max-width: 600px) {
        flex-direction: column;
        align-items: center;
    }
`